/* import __COLOCATED_TEMPLATE__ from './hidden-details.hbs'; */
import Component from "@ember/component";
import { action } from "@ember/object";

export default Component.extend({
  @action
  expand() {
    this.set("expanded", true);
  },
});
